export default "__VITE_ASSET__FlVQp7b8__"